import PeanutButterProduct from 'models/PeanutButterProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import PeanutButterPackage from './PeanutButterPackage'

const productOptions = {
  packagingInfo: <PeanutButterPackage />,
  productTitle: 'Peanut Butter',
  model: PeanutButterProduct,
  validCategories: ['06'],
  validSubCategories: ['001'],
}

const PeanutButter = () => <ProductForm product={productOptions} />

export default PeanutButter

export const getPeanutButterPackage = newProduct => {
  const newPeanutButterPackage = {
    UPC: newProduct.UPC,
    LegumeProductType: 'Peanut Butter',
    SaltContent: null,
    BeanPeaLentilType: null,
    BeanPeaLentilSize: null,
    PBContainerSize: newProduct.PBContainerSize,
    PBTexture:
      newProduct.PBTexture === 'Other'
        ? newProduct.otherTexture
        : newProduct.PBTexture,
  }
  return newPeanutButterPackage
}

export const updatePeanutButterPackage = newProduct => {
  const newPeanutButterPackage = {
    UPC: newProduct.UPC,
    LegumeProductType: 'Peanut Butter',
    SaltContent: null,
    BeanPeaLentilType: null,
    BeanPeaLentilSize: null,
    PBContainerSize: newProduct.PBContainerSize,
    PBTexture:
      newProduct.PBTexture === 'Other'
        ? newProduct.otherTexture
        : newProduct.PBTexture,
  }
  return newPeanutButterPackage
}
